import { render } from "./Proclim.vue?vue&type=template&id=d52053e2"
import script from "./Proclim.vue?vue&type=script&lang=js"
export * from "./Proclim.vue?vue&type=script&lang=js"

import exportComponent from "/opt/cah/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__